import React, { useState, useEffect } from 'react';
import './imageSlider.scss';
import LoadingBar from '../../../components/global/loadingBar';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/Project/close.svg';
import Modal from '../../../components/modals';
import Slider from 'react-slick';
import { gql } from '@apollo/client';
import _ from 'lodash';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { withRouter } from '../../../../services/withRoute';

const getFileSignedUrl = gql`
	query RootQuery($workspaceId: ID!, $projectId: ID!, $fileId: ID!) {
		getProjectFileSignedUrl(workspaceId: $workspaceId, projectId: $projectId, fileId: $fileId)
	}
`;

const settingsMain = {
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	asNavFor: '.slider-nav',
	lazyLoad: 'ondemand',
};

const settingsThumbs = {
	slidesToShow: 3,
	slidesToScroll: 1,
	asNavFor: '.slider-for',
	dots: true,
	centerMode: true,
	swipeToSlide: true,
	focusOnSelect: true,
	centerPadding: '10px',
	lazyLoad: 'progressive',
};

class ImageSlider extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			nav1: null,
			nav2: null,
			isLoading: true,
			slidesData: props.slidesData,
		};
	}
	slider1 = null;
	slider2 = null;
	/* const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  useEffect(() => {

    setNav1(slider1);
    setNav2(slider2);

  }); */

	componentDidMount = async () => {
		let slidesData = this.state.slidesData;
		let count = 0;
		while (count < _.size(slidesData)) {
			let getSignedUrlVariables = {
				fileId: slidesData[count]._id,
				workspaceId: _.filter(this.props.associatedTenants, {
					_id: this.props.shootInfo.tenantId,
				})[0].workspaceId,
				projectId: this.props.shootInfo.projectId,
			};

			let res = await this.getFileSignedUrl(getFileSignedUrl, getSignedUrlVariables);
			if (res !== false) {
				slidesData[count].src = res;
			}

			count = count + 1;
		}
		this.setState(
			{
				slidesData,
				isLoading: false,
			},
			() => {
				this.setState({
					nav1: this.slider1,
					nav2: this.slider2,
				});
			},
		);
	};

	render() {
		return (
			<Modal
				handleClose={() => this.props.close()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="image-slider-modal-center">
					<span className="close-icn" onClick={() => this.props.close()}>
						<CloseIcon />
					</span>
					{this.state.isLoading ? (
						<LoadingBar />
					) : (
						<div className="slider-wrapper">
							<div className="main-slider-wrap">
								<Slider
									{...settingsMain}
									asNavFor={this.state.nav2}
									ref={(slider) => (this.slider1 = slider)}
								>
									{this.state.slidesData.map((slide) => (
										<div className="slick-slide" key={slide._id}>
											<h2 className="slick-slide-title">
												{slide.originalFileName}
											</h2>
											<img className="slick-slide-image" src={slide.src} />
										</div>
									))}
								</Slider>
							</div>
							<div className="thumbnail-slider-wrap">
								<Slider
									{...settingsThumbs}
									asNavFor={this.state.nav1}
									ref={(slider) => (this.slider2 = slider)}
								>
									{this.state.slidesData.map((slide) => (
										<div className="slick-slide" key={slide._id}>
											<img className="slick-slide-image" src={slide.src} />
										</div>
									))}
								</Slider>
							</div>
						</div>
					)}
				</div>
			</Modal>
		);
	}
}

export default withRouter(ImageSlider);
